angular.module('bb.almanac', []);

require('./almanac.service');
